import React from 'react'
import { Tooltip } from '@mui/joy'
import { abbreviateRating } from '@numeo/types'

export interface PrefetchedFactoringBadgeProps {
    grade: string
    source?: string
    loadsCount?: number
    color?: string
}

/** Inline factoring badge driven by prefetched data from the search pipeline.
 *  No API call — used by agentic-hub so the grade is visible without expanding. */
export const PrefetchedFactoringBadge: React.FC<PrefetchedFactoringBadgeProps> = ({ grade, source, loadsCount, color: apiColor }) => {
    const { abbrev, color: derivedColor } = abbreviateRating(grade)
    const color = apiColor || derivedColor
    let tooltipText = `${source?.toUpperCase() || 'Factoring'} Rating: ${grade}`
    if (loadsCount != null) tooltipText += ` • ${loadsCount.toLocaleString()} loads`
    return (
        <Tooltip title={tooltipText} arrow placement="top">
            <span
                className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-bold text-white flex-shrink-0 tabular-nums"
                style={{ backgroundColor: color }}
            >
                {abbrev}
                {loadsCount != null && (
                    <>
                        <span className="w-px h-2.5 bg-white/40" />
                        <span className="font-semibold">{loadsCount.toLocaleString()}</span>
                    </>
                )}
            </span>
        </Tooltip>
    )
}
